import styled from "styled-components"
import { Brand } from './Style'

export const NavMobile = styled.div`
    padding: 20px 0px;
    background-color: white;
    position: fixed;
    top: 0;
    z-index: 30;
    height: 100%;
    width: 223px;
    transform:translateX(-243px);
    box-shadow: 0 5px 20px rgb(0 0 0 / 10%);
    text-align: center;
    overflow: scroll;
    @media (max-width:1000px){
        transform: ${props => props.active ? " translateX(0px)" : "translateX(-243px)"};
    } 
    `;

export const MobileBrand = styled(Brand)`
h2{
    color:black;
}
`;

export const NavLinks = styled.div`
text-align: start;
margin: 40px 0px;
border-top: 1px solid #eaeaea;
a{
    font-size: 12px;
    display: block;
    padding: 12px 19px;
    /* margin-bottom: 10px; */
    border-bottom: 1px solid #eaeaea;
    color:black;
    font-weight:600;
    cursor: pointer;
    :hover{
        padding-left: 50px;
    }
}
.activeLink{
    border-left: 8px solid #00b06a;
    }
`;

export const DropDown = styled.div`
position: relative;
:hover >ul{
    height: 129px;
}
`;
export const DropDownContant = styled.ul`
height: 0px;
/* background-color: red; */
overflow: hidden;
background-color:#f7f7f7;
li a{
    padding-left: 53px;
    border-bottom: 1px solid #d5d5d5;
}
`;
export const NavBtns = styled.div`
padding: 20px 10px;
a{
    background-color: #2a96d1;
     margin-right: 11px;
    text-align: center;
    line-height: 40px;
    border-radius: 2px;
    color: white;
    font-weight: 600;
    font-size: 14px;
    display: inline-block;
    padding: 0 20px;
    height: 40px;
    border:none;
    :hover{
        padding-left: 20px;
    }
}
a:nth-child(1){
    background-color:var(--primaryColor);
}
`;